<template>
  <div :class="['rbu-item-module', { ignored: module.ignored }]">
    <!-- Header -->
    <div class="rbu-item-module-header">
      <h3 class="rbu-item-module-name">
        Module {{ String.fromCharCode(65 + idx) }}
      </h3>
      <v-text-field
        outlined
        dense
        hide-details
        label="Name"
        :value="module.name"
        style="max-width: 37rem"
        @input="onUpdate({ name: $event })"
      ></v-text-field>
      <v-text-field
        outlined
        dense
        hide-details
        label="Portion"
        type="number"
        min="0"
        step="1"
        suffix="%"
        style="max-width: 100px; margin-left: 2rem"
        :value="module.portion"
        @input="onUpdate({ portion: $event })"
      ></v-text-field>
      <v-spacer></v-spacer>

      <v-btn text color="primary" @click="$emit('delete')"
        >Delete Module
      </v-btn>
      <v-checkbox
        dense
        hide-details
        class="ignore-checkbox ml-4"
        :input-value="module.ignored"
        @change="onUpdate({ ignored: $event })"
      >
        <template #label>
          <label
            style="
              font-family: Roboto, sans-serif;
              font-size: 14px;
              font-weight: 500;
              font-stretch: 100%;
              letter-spacing: 1.25px;
              line-height: normal;
              text-indent: 1.25px;
            "
            >IGNORE MODULE</label
          >
        </template>
      </v-checkbox>
      <v-btn
        icon
        :disabled="!module.ignored && !collapsed"
        class="ml-2"
        color="primary"
        @click="collapsed = !collapsed"
      >
        <v-icon v-if="collapsed">mdi-plus-box-outline</v-icon>
        <v-icon v-else>mdi-minus-box-outline</v-icon>
      </v-btn>
    </div>

    <!-- Table -->
    <div v-if="!collapsed" class="rbu-item-module-content">
      <div class="rbu-item-module-table-wrapper">
        <div class="rbu-item-module-table">
          <!-- Table Header -->
          <div class="rbu-item-module-table-header rbu-item-module-table-row">
            <div class="rbu-item-module-row-column-1"></div>
            <div class="rbu-item-module-row-column-2"></div>
            <div class="rbu-item-module-row-column-3">#</div>
            <div class="rbu-item-module-row-column-value">Value</div>
            <div class="rbu-item-module-row-column-multiplier">Multiplier</div>
            <div class="rbu-item-module-row-column-formula">Formula</div>
            <div class="rbu-item-module-row-column-descriptions">
              Description
            </div>
            <div class="rbu-item-module-row-column-actions"></div>
          </div>
          <!-- SELECT -->
          <div
            :class="[
              'rbu-item-module-table-row',
              {
                'no-border':
                  [
                    RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES,
                    RBU_MODULE_BASE_RATE_TYPE.DATAPOINT,
                  ].indexOf(module.base_rate_type) !== -1,
              },
            ]"
          >
            <div class="rbu-item-module-row-column-1">Base Cost</div>
            <div class="rbu-item-module-row-column-2">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 0.75rem;
                "
              >
                <v-select
                  outlined
                  dense
                  hide-details
                  attach
                  :items="baseRateTypeOptions"
                  :value="module.base_rate_type"
                  @input="onUpdate({ base_rate_type: $event })"
                ></v-select>
                <v-textarea
                  v-if="
                    module.base_rate_type ===
                    RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES
                  "
                  style="max-width: 6rem"
                  outlined
                  dense
                  hide-details
                  rows="1"
                  auto-grow
                  label="Unit"
                  :value="module.tender_rate_unit"
                  @input="onUpdate({ tender_rate_unit: $event })"
                ></v-textarea>
                <v-textarea
                  v-if="
                    module.base_rate_type ===
                    RBU_MODULE_BASE_RATE_TYPE.DATAPOINT
                  "
                  style="max-width: 6rem"
                  outlined
                  dense
                  hide-details
                  rows="1"
                  auto-grow
                  label="Unit"
                  :value="module.datapoint_unit"
                  @input="onUpdate({ datapoint_unit: $event })"
                ></v-textarea>
              </div>
            </div>
            <NsrItemModuleTenderRates
              :rates="module.tender_rates"
              @input="onUpdate({ tender_rates: $event })"
              v-if="
                module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES
              "
            ></NsrItemModuleTenderRates>
          </div>

          <!-- TENDER RATES -->
          <div
            class="rbu-item-module-table-row"
            v-if="
              module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES
            "
          >
            <div class="rbu-item-module-row-column-1"></div>
            <div class="rbu-item-module-row-column-2">
              <v-btn outlined color="primary" @click="addTenderRate"
                >ADD NEW
              </v-btn>
            </div>
          </div>

          <!-- DATAPOINT -->
          <AsorItemModuleDatapoints
            :datapoints="module.datapoints"
            @input="onUpdate({ datapoints: $event })"
            v-if="module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.DATAPOINT"
          ></AsorItemModuleDatapoints>
          <div
            class="rbu-item-module-table-row"
            v-if="module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.DATAPOINT"
          >
            <div class="rbu-item-module-row-column-1"></div>
            <div class="rbu-item-module-row-column-2">
              <v-btn outlined color="primary" @click="addDataPoint"
                >ADD NEW
              </v-btn>
            </div>
          </div>

          <!-- Tender rate sum / avg -->
          <div class="rbu-item-module-table-row no-border">
            <div
              class="rbu-item-module-row-column-1"
              style="align-self: center"
            ></div>
            <div
              class="rbu-item-module-row-column-2"
              style="align-self: center"
            >
              <v-select
                outlined
                dense
                hide-details
                attach
                :items="tenderRateModeOptions"
                :value="module.tender_rate_mode"
                @input="onUpdate({ tender_rate_mode: $event })"
                v-if="
                  module.base_rate_type ===
                    RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES &&
                  module.tender_rates &&
                  module.tender_rates.length > 1
                "
              ></v-select>

              <v-select
                outlined
                dense
                hide-details
                attach
                :items="tenderRateModeOptions"
                :value="module.datapoint_mode"
                @input="onUpdate({ datapoint_mode: $event })"
                v-if="
                  module.base_rate_type ===
                    RBU_MODULE_BASE_RATE_TYPE.DATAPOINT &&
                  module.datapoints &&
                  module.datapoints.length > 1
                "
              ></v-select>
            </div>
            <div
              class="rbu-item-module-row-column-3"
              style="align-self: center"
            ></div>
            <div
              class="rbu-item-module-row-column-value"
              style="align-self: center"
            >
              <b v-if="showBeforeAdjustment">{{
                $parseCurrency(beforeAdjustments)
              }}</b>
            </div>
            <div
              class="rbu-item-module-row-column-multiplier"
              style="align-self: center"
            ></div>
            <div
              class="rbu-item-module-row-column-formula"
              style="align-self: center"
            >
              <div
                class="flex"
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  gap: 5px;
                "
                v-if="
                  showBeforeAdjustment &&
                  module.base_rate_type ===
                    RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES
                "
              >
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  :value="tenderFormulaPrefix"
                  @input="onTenderFormulaUpdate($event, tenderFormulaSuffix)"
                ></v-textarea>

                <div class="rbu-rate-box">
                  {{
                    module.tender_rates && module.tender_rates.length > 1
                      ? module.tender_rate_mode ===
                        RBU_MODULE_TENDER_RATE_MODE.SUM
                        ? "Sum"
                        : "Avg"
                      : "Rate"
                  }}
                  <br />({{ $parseCurrency(beforeAdjustmentsNoFormula) }})
                </div>

                <v-textarea
                  outlined
                  dense
                  hide-details
                  auto-grow
                  rows="1"
                  :value="tenderFormulaSuffix"
                  @input="onTenderFormulaUpdate(tenderFormulaPrefix, $event)"
                ></v-textarea>
              </div>

              <div
                class="flex"
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  gap: 5px;
                "
                v-if="
                  showBeforeAdjustment &&
                  module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.DATAPOINT
                "
              >
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  :value="datapointFormulaPrefix"
                  @input="
                    onDatapointFormulaUpdate($event, datapointFormulaSuffix)
                  "
                ></v-textarea>

                <div class="rbu-rate-box">
                  {{
                    module.datapoints && module.datapoints.length > 1
                      ? module.datapoint_mode ===
                        RBU_MODULE_TENDER_RATE_MODE.SUM
                        ? "Sum"
                        : "Avg"
                      : "Rate"
                  }}
                  <br />({{ $parseCurrency(beforeAdjustmentsNoFormula) }})
                </div>
                <v-textarea
                  outlined
                  dense
                  hide-details
                  auto-grow
                  rows="1"
                  :value="datapointFormulaSuffix"
                  @input="
                    onDatapointFormulaUpdate(datapointFormulaPrefix, $event)
                  "
                ></v-textarea>
              </div>
            </div>
            <div
              class="rbu-item-module-row-column-descriptions"
              style="align-self: center"
            >
              <v-textarea
                v-if="showBeforeAdjustment"
                outlined
                auto-grow
                rows="1"
                dense
                hide-details
                placeholder="Description"
                :value="module.tender_rate_descriptions"
                @input="onUpdate({ tender_rate_descriptions: $event })"
              ></v-textarea>
            </div>
            <div class="rbu-item-module-row-column-actions"></div>
          </div>

          <!-- Adjustment -->
          <div
            class="rbu-item-module-table-row no-border"
            v-if="module.adjustment_value_first"
          >
            <div class="rbu-item-module-row-column-1">Adjustment</div>
            <div class="rbu-item-module-row-column-2">Adjustment in $</div>
            <div class="rbu-item-module-row-column-3"></div>
            <div class="rbu-item-module-row-column-value d-flex align-center">
              {{ $parseCurrency(module.adjustment_value || 0) }}
            </div>
            <div class="rbu-item-module-row-column-multiplier"></div>
            <div class="rbu-item-module-row-column-formula">
              <v-textarea
                outlined
                dense
                hide-details
                placeholder="Formula"
                auto-grow
                rows="1"
                clearable
                :value="module.adjustment_value_formula"
                @input="onAdjustmentValueFormulaUpdate"
              ></v-textarea>
            </div>
            <div class="rbu-item-module-row-column-descriptions">
              <v-textarea
                outlined
                auto-grow
                rows="1"
                dense
                hide-details
                placeholder="Description"
                :value="module.adjustment_value_descriptions"
                @input="onUpdate({ adjustment_value_descriptions: $event })"
              ></v-textarea>
            </div>
            <div class="rbu-item-module-row-column-actions">
              <v-btn
                icon
                color="primary"
                @click="
                  onUpdate({
                    adjustment_value_first: !module.adjustment_value_first,
                  })
                "
              >
                <v-icon>mdi-swap-vertical</v-icon>
              </v-btn>
            </div>
          </div>
          <div
            :class="[
              'rbu-item-module-table-row',
              { 'no-border': !module.adjustment_value_first },
            ]"
          >
            <div class="rbu-item-module-row-column-1">
              <span v-if="!module.adjustment_value_first">Adjustment</span>
            </div>
            <div class="rbu-item-module-row-column-2">
              Adjustment in %
              {{
                module.adjustment_percentage
                  ? `(${(
                      parseFloat(module.adjustment_percentage) - 100
                    ).toFixed(2)}%)`
                  : ""
              }}
            </div>
            <div class="rbu-item-module-row-column-3"></div>
            <div class="rbu-item-module-row-column-value"></div>
            <div
              class="rbu-item-module-row-column-multiplier d-flex align-center"
            >
              {{ $parseNumber(module.adjustment_percentage || 0) }}%
            </div>
            <div class="rbu-item-module-row-column-formula">
              <v-textarea
                outlined
                dense
                hide-details
                placeholder="100"
                auto-grow
                rows="1"
                clearable
                :value="module.adjustment_percentage_formula"
                @input="onAdjustmentPercentageFormulaUpdate"
              ></v-textarea>
            </div>
            <div class="rbu-item-module-row-column-descriptions">
              <v-textarea
                outlined
                auto-grow
                rows="1"
                dense
                hide-details
                placeholder="Description"
                :value="module.adjustment_percentage_descriptions"
                @input="
                  onUpdate({ adjustment_percentage_descriptions: $event })
                "
              ></v-textarea>
            </div>
            <div class="rbu-item-module-row-column-actions">
              <v-btn
                icon
                color="primary"
                @click="
                  onUpdate({
                    adjustment_value_first: !module.adjustment_value_first,
                  })
                "
              >
                <v-icon>mdi-swap-vertical</v-icon>
              </v-btn>
            </div>
          </div>
          <div
            class="rbu-item-module-table-row"
            v-if="!module.adjustment_value_first"
          >
            <div class="rbu-item-module-row-column-1"></div>
            <div class="rbu-item-module-row-column-2">Adjustment in $</div>
            <div class="rbu-item-module-row-column-3"></div>
            <div class="rbu-item-module-row-column-value d-flex align-center">
              {{ $parseCurrency(module.adjustment_value || 0) }}
            </div>
            <div class="rbu-item-module-row-column-multiplier"></div>
            <div class="rbu-item-module-row-column-formula">
              <v-textarea
                outlined
                dense
                hide-details
                placeholder="Formula"
                auto-grow
                rows="1"
                clearable
                :value="module.adjustment_value_formula"
                @input="onAdjustmentValueFormulaUpdate"
              ></v-textarea>
            </div>
            <div class="rbu-item-module-row-column-descriptions">
              <v-textarea
                outlined
                auto-grow
                rows="1"
                dense
                hide-details
                placeholder="Description"
                :value="module.adjustment_value_descriptions"
                @input="onUpdate({ adjustment_value_descriptions: $event })"
              ></v-textarea>
            </div>
            <div class="rbu-item-module-row-column-actions">
              <v-btn
                icon
                color="primary"
                @click="
                  onUpdate({
                    adjustment_value_first: !module.adjustment_value_first,
                  })
                "
              >
                <v-icon>mdi-swap-vertical</v-icon>
              </v-btn>
            </div>
          </div>

          <!-- Fluctuation -->
          <ASorItemFluctuations
            :fluctuations="module.fluctuations"
            @input="onUpdate({ fluctuations: $event })"
          ></ASorItemFluctuations>
          <div class="rbu-item-module-table-row">
            <div class="rbu-item-module-row-column-1"></div>
            <div class="rbu-item-module-row-column-2">
              <v-btn outlined color="primary" @click="addFluctuation"
                >ADD FLUCTUATION
              </v-btn>
            </div>
          </div>

          <!-- Sub Total -->
          <div class="rbu-item-module-table-row no-border">
            <div class="rbu-item-module-row-column-1"></div>
            <div class="rbu-item-module-row-column-2 text-right">
              Subtotal{{ module.name ? ` (${module.name})` : "" }}:
            </div>
            <div class="rbu-item-module-row-column-3"></div>
            <div class="rbu-item-module-row-column-value">
              <b>{{ $parseCurrency(module.sub_total) }}</b>
            </div>
            <div class="rbu-item-module-row-column-multiplier"></div>
            <div class="rbu-item-module-row-column-formula"></div>
            <div class="rbu-item-module-row-column-descriptions"></div>
            <div class="rbu-item-module-row-column-actions"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import {
  RBU_ITEM_MODULE_CATEGORY,
  RBU_MODULE_BASE_RATE_TYPE,
  RBU_MODULE_TENDER_RATE_MODE,
} from "@/constants";
import NsrItemModuleTenderRates from "@/components/nsr/NsrItemModuleTenderRates.vue";
import AsorItemModuleDatapoints from "@/components/asor/AsorItemModuleDatapoints.vue";
import ASorItemFluctuations from "@/components/asor/ASorItemFluctuations.vue";
import floatingPointFix from "js-floating-point";
export default {
  name: "ASorItemModule",
  components: {
    ASorItemFluctuations,
    AsorItemModuleDatapoints,
    NsrItemModuleTenderRates,
  },
  props: {
    module: Object,
    idx: Number,
  },
  setup(props, { root, emit }) {
    const collapsed = ref(false);
    const moduleCategoryOptions = ref([
      { text: "Labour", value: RBU_ITEM_MODULE_CATEGORY.LABOUR },
      { text: "Material", value: RBU_ITEM_MODULE_CATEGORY.MATERIAL },
      { text: "Other", value: RBU_ITEM_MODULE_CATEGORY.OTHER },
    ]);

    const baseRateTypeOptions = ref([
      {
        text: "Quoted rates / Tender rates",
        value: RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES,
      },
      { text: "C&S cost data", value: RBU_MODULE_BASE_RATE_TYPE.DATAPOINT },
      // {text: 'Past SoR Rate', value: RBU_MODULE_BASE_RATE_TYPE.PAST_SOR_RATE},
    ]);

    const tenderRateModeOptions = computed(() => {
      return [
        { text: "Average", value: RBU_MODULE_TENDER_RATE_MODE.AVERAGE },
        { text: "Sum", value: RBU_MODULE_TENDER_RATE_MODE.SUM },
      ];
    });

    const tenderFormulaPrefix = computed(() => {
      const components = (props.module.tender_rate_formula || "").split(
        "{{value}}"
      );

      if (components.length === 2) {
        return components[0];
      }
      return "";
    });
    const tenderFormulaSuffix = computed(() => {
      const components = (props.module.tender_rate_formula || "").split(
        "{{value}}"
      );

      if (components.length === 2) {
        return components[1];
      }
      return "";
    });

    const datapointFormulaPrefix = computed(() => {
      const components = (props.module.datapoint_formula || "").split(
        "{{value}}"
      );

      if (components.length === 2) {
        return components[0];
      }
      return "";
    });
    const datapointFormulaSuffix = computed(() => {
      const components = (props.module.datapoint_formula || "").split(
        "{{value}}"
      );

      if (components.length === 2) {
        return components[1];
      }
      return "";
    });

    const showBeforeAdjustment = computed(() => {
      return true;
      // return (
      //   (props.module.tender_rates || []).length > 1 ||
      //   (props.module.datapoints || []).length > 1
      // );
    });

    const onTenderFormulaUpdate = function (prefix, suffix) {
      // console.log(`${prefix}{{value}}${suffix}`);
      onUpdate({ tender_rate_formula: `${prefix}{{value}}${suffix}` });
    };

    const onDatapointFormulaUpdate = function (prefix, suffix) {
      // console.log(`${prefix}{{value}}${suffix}`);
      onUpdate({ datapoint_formula: `${prefix}{{value}}${suffix}` });
    };

    const beforeAdjustmentsNoFormula = computed(() => {
      const module = props.module;

      let total = 0;
      if (module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES) {
        let validCount = 0;
        let tender_rate_count = 0;
        (module.tender_rates || []).forEach((m) => {
          tender_rate_count++;
          if (!m.ignored) {
            let parsed = parseFloat(m.value);
            if (parsed) {
              total = floatingPointFix(total + parsed);
              validCount++;
            }
          }
        });

        if (
          module.tender_rate_mode === RBU_MODULE_TENDER_RATE_MODE.AVERAGE &&
          validCount > 0
        ) {
          total = floatingPointFix(total / validCount);
        }
      } else if (
        module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.DATAPOINT
      ) {
        let dp_count = 0;
        let validCount = 0;
        const dps = module.datapoints || [];
        dp_count = dps.length;
        dps.forEach((dp) => {
          if (!dp.ignored && dp.datapoint && dp.datapoint.value) {
            validCount += 1;
            try {
              let dp_formula = dp.formula || "{{VALUE}}";
              let dp_value = dp_formula.replace(
                "{{VALUE}}",
                dp.datapoint.value
              );
              let parsed =
                Math.round(parseFloat(floatingPointFix(eval(dp_value))) * 100) /
                100;
              total = floatingPointFix(total + parsed);
            } catch (e) {
              console.log(e);
            }
          }
        });

        if (
          module.datapoint_mode === RBU_MODULE_TENDER_RATE_MODE.AVERAGE &&
          validCount > 0
        ) {
          total = floatingPointFix(total / validCount);
        }
      }

      return Math.round(floatingPointFix(total * 100)) / 100;
    });

    const beforeAdjustments = computed(() => {
      const module = props.module;

      let total = 0;
      if (module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES) {
        let validCount = 0;
        let tender_rate_count = 0;
        (module.tender_rates || []).forEach((m) => {
          tender_rate_count++;
          if (!m.ignored) {
            let parsed = parseFloat(m.value);
            if (parsed) {
              total = floatingPointFix(total + parsed);
              validCount++;
            }
          }
        });

        if (
          module.tender_rate_mode === RBU_MODULE_TENDER_RATE_MODE.AVERAGE &&
          validCount > 0
        ) {
          total = floatingPointFix(total / validCount);
        }

        if (module.tender_rate_formula) {
          // rounding before tender_rate_formula
          total = Math.round(floatingPointFix(total * 100)) / 100;
          try {
            if (module.tender_rate_formula.includes("{{value}}")) {
              const formula = module.tender_rate_formula.replaceAll(
                "{{value}}",
                total
              );
              total = floatingPointFix(eval(formula));
            } else {
              const formula = total + module.tender_rate_formula;
              total = floatingPointFix(eval(formula));
            }
          } catch (e) {
            console.debug(e);
          }
        }
      } else if (
        module.base_rate_type === RBU_MODULE_BASE_RATE_TYPE.DATAPOINT
      ) {
        let dp_count = 0;
        let validCount = 0;
        const dps = module.datapoints || [];
        dp_count = dps.length;
        dps.forEach((dp) => {
          if (!dp.ignored && dp.datapoint && dp.datapoint.value) {
            validCount += 1;
            try {
              let dp_formula = dp.formula || "{{VALUE}}";
              let dp_value = dp_formula.replace(
                "{{VALUE}}",
                dp.datapoint.value
              );
              let parsed =
                Math.round(
                  floatingPointFix(
                    parseFloat(floatingPointFix(eval(dp_value))) * 100
                  )
                ) / 100;
              total = floatingPointFix(total + parsed);
            } catch (e) {
              console.log(e);
            }
          }
        });

        if (
          module.datapoint_mode === RBU_MODULE_TENDER_RATE_MODE.AVERAGE &&
          validCount > 0
        ) {
          total = floatingPointFix(total / validCount);
        }

        if (module.datapoint_formula) {
          // rounding before tender_rate_formula
          total = Math.round(floatingPointFix(total * 100)) / 100;
          try {
            if (module.datapoint_formula.includes("{{value}}")) {
              const formula = module.datapoint_formula.replaceAll(
                "{{value}}",
                total
              );
              total = floatingPointFix(eval(formula));
            } else {
              const formula = total + module.datapoint_formula;
              total = floatingPointFix(eval(formula));
            }
          } catch (e) {
            console.debug(e);
          }
        }
      }

      return Math.round(floatingPointFix(total * 100)) / 100;
    });

    const afterAdjustments = computed(() => {
      const module = props.module;

      let sub_total = beforeAdjustments.value;

      function applyValueAdjustment() {
        if (module.adjustment_value && parseFloat(module.adjustment_value)) {
          sub_total = floatingPointFix(
            sub_total + parseFloat(module.adjustment_value)
          );
        }
      }

      function applyPercentageAdjustment() {
        if (
          module.adjustment_percentage &&
          parseFloat(module.adjustment_percentage)
        ) {
          sub_total = floatingPointFix(
            (sub_total * parseFloat(module.adjustment_percentage)) / 100
          );
        }
      }
      let formula = sub_total;
      if (module.adjustment_value_first) {
        applyValueAdjustment();
        applyPercentageAdjustment();
      } else {
        applyPercentageAdjustment();
        applyValueAdjustment();
      }

      (module.fluctuations || []).forEach((f) => {
        if (f.sub_total) {
          const no_round = parseFloat(f.sub_total);
          // const round_up_2 = Math.ceil(no_round * 10000) / 10000;
          const round_up_2 =
            Math.round(floatingPointFix(no_round * 10000)) / 10000;
          formula += "*" + `(${no_round})` + round_up_2;
          sub_total = floatingPointFix(sub_total * round_up_2);
        }
      });

      if (module.portion) {
        formula += "*" + `${module.portion / 100}`;
        sub_total = floatingPointFix(
          (sub_total * parseFloat(module.portion)) / 100
        );
      }

      // console.log("formula : " + formula);
      return Math.round(floatingPointFix(sub_total * 100)) / 100;
    });

    const addTenderRate = function () {
      onUpdate({
        tender_rates: _.concat(props.module.tender_rates || [], {}),
      });
    };

    const addDataPoint = function () {
      onUpdate({
        datapoints: _.concat(props.module.datapoints || [], {
          period: "BASE_END",
        }),
      });
    };

    const addFluctuation = function () {
      onUpdate({
        fluctuations: _.concat(props.module.fluctuations || [], {
          previous_period: "BASE_START",
          current_period: "BASE_END",
        }),
      });
    };

    const onAdjustmentValueFormulaUpdate = function (evt) {
      console.debug("onAdjustmentValueFormulaUpdate", evt);

      let value;

      if (evt) {
        try {
          value = floatingPointFix(eval(evt));
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = 0;
      }

      value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;

      onUpdate({
        adjustment_value: value,
        adjustment_value_formula: evt,
      });
    };

    const onAdjustmentPercentageFormulaUpdate = function (evt) {
      console.debug("onAdjustmentPercentageFormulaUpdate", evt);

      let value;

      if (evt) {
        try {
          value = floatingPointFix(eval(evt));
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = 100;
      }

      value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;

      onUpdate({
        adjustment_percentage: value,
        adjustment_percentage_formula: evt,
      });
    };
    const onUpdate = function (evt) {
      console.debug("Module Update: ", evt);
      if (evt.tender_rate_formula === null) {
        evt.tender_rate_formula = "";
      }

      let updates = {
        ...props.module,
        ...evt,
      };

      emit("update", updates);
    };

    onMounted(() => {
      onUpdate({});
    });

    watch(
      () => props.module.base_rate_type,
      (newValue) => {
        if (
          newValue === RBU_MODULE_BASE_RATE_TYPE.TENDER_RATES &&
          (props.module.tender_rates || []).length === 0
        ) {
          addTenderRate();
        } else if (
          newValue === RBU_MODULE_BASE_RATE_TYPE.DATAPOINT &&
          (props.module.datapoints || []).length === 0
        ) {
          addDataPoint();
        }
      }
    );

    watch(
      () => props.module,
      (newValue) => {
        const sub_total = afterAdjustments.value;
        if (newValue.sub_total !== sub_total) {
          onUpdate({ sub_total });
        }
      },
      { deep: true }
    );

    return {
      collapsed,
      moduleCategoryOptions,
      baseRateTypeOptions,
      tenderRateModeOptions,

      showBeforeAdjustment,
      beforeAdjustments,
      afterAdjustments,

      addTenderRate,
      addDataPoint,
      addFluctuation,
      onAdjustmentValueFormulaUpdate,
      onAdjustmentPercentageFormulaUpdate,
      onUpdate,

      RBU_ITEM_MODULE_CATEGORY,
      RBU_MODULE_BASE_RATE_TYPE,
      RBU_MODULE_TENDER_RATE_MODE,

      onTenderFormulaUpdate,
      tenderFormulaPrefix,
      tenderFormulaSuffix,
      beforeAdjustmentsNoFormula,

      onDatapointFormulaUpdate,
      datapointFormulaPrefix,
      datapointFormulaSuffix,
    };
  },
};
</script>

<style lang="less"></style>
